import { render, staticRenderFns } from "./VideoPlayerLand.vue?vue&type=template&id=3b6198c8&scoped=true"
import script from "./VideoPlayerLand.vue?vue&type=script&lang=js"
export * from "./VideoPlayerLand.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerLand.vue?vue&type=style&index=0&id=3b6198c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6198c8",
  null
  
)

export default component.exports